import { useEffect, useState } from 'react'

export const useInBackgroundChange = () => {
  const [inBackground, setInBackground] = useState(false)

  const onChange = () => {
    const state = document.visibilityState

    let value = true

    if (state === 'visible') {
      value = false
    } else {
      value = true
    }

    setInBackground(value)
  }

  useEffect(() => {
    document.addEventListener('visibilitychange', onChange)

    return () => document.removeEventListener('visibilitychange', onChange)
  }, [])

  return inBackground
}
